import { configAxiosOpportunities } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getOpportunities = async queriesStrings => {
    const api = configAxiosOpportunities();
    const { data } = await api.get(`${ENDPOINTS.OPPORTUNITIES}${queriesStrings}`);
    return { data };
};

export const setFeedBackOpportunities = async (opportunityId, feedBack, payload = null) => {
    const api = configAxiosOpportunities();
    const { data } = await api.put(`${ENDPOINTS.OPPORTUNITIES}${opportunityId}/${feedBack}/`, payload);
    return { data };
};

export const setPatchOpportunities = async (opportunityId, payload = null) => {
    const api = configAxiosOpportunities();
    const { data } = await api.patch(`${ENDPOINTS.OPPORTUNITIES}${opportunityId}/`, payload);
    return { data };
};
